export const ADD_NEWS_NOTIFICATION = 'ADD_NEWS_NOTIFICATION';
export const REMOVE_NEWS_NOTIFICATION = 'REMOVE_NEWS_NOTIFICATION';
